<template>
        <div class="property-listing card rounded-3" :class="props.border ? 'border' : 'border-0'">
            <router-link v-if="localizedExhibitPath(props.item)"
                                :to="localizedExhibitPath(props.item)">
                <div class="abx-thumb" data-overlay="3">
                    <img :src="`${props.item.logo}`" class="img-fluid" alt="exhibit logo">
                </div>
            </router-link>

            <div class="position-absolute top-0 start-0 w-100 p-3">
                <div class="d-flex justify-content-between align-items-stretch">
                    <div class="d-flex flex-column text-start">
                        <div class="label1 bg-primary text-light px-2 d-flex align-items-center">{{ props.item.city_name || 'Unknown City' }}</div>
                        <div class="label1 bg-primary text-light px-2 d-flex align-items-center mt-1">{{ status }}</div>
                    </div>
                    <div class="d-flex flex-column text-end">
                        <div class="label1 bg-primary text-light px-2 d-flex align-items-center">{{ props.item.start_date || 'Unknown start date' }}</div>
                        <div class="label1 bg-primary text-light px-2 mt-1">{{ props.item.end_date || 'Unknown end date' }}</div>
                    </div>
                </div>
            </div>

            <div class="position-absolute bottom-0 start-50 translate-middle-x w-100 text-center mb-3">
                <div class="label1 bg-primary text-light px-2">{{ props.item.name || 'Unknown exhibit name' }}</div>
            </div>
        </div>
                            
</template>
<script setup>
import { computed } from 'vue';
import { defineProps } from 'vue';
import { useI18n } from 'vue-i18n';

const { t,locale } = useI18n();
const props = defineProps({
  item: Object,
  border: Boolean
});

const localizedExhibitPath = (item) => {
  const currentSlug = item.slug?.[locale.value]

  if (!currentSlug) return null  

  return `/${locale.value}/exhibit/${currentSlug}`
}
const parseLocalDate = (dateStr) => {
  const [year, month, day] = dateStr.split('-');
  return new Date(year, month - 1, day);
};
const status = computed(() => {
  if (!props.item.start_date || !props.item.end_date) return t('Unknown');

  const now = new Date();

  const start = parseLocalDate(props.item.start_date);
  start.setHours(0, 0, 0, 0);

  const end = parseLocalDate(props.item.end_date);
  end.setHours(23, 59, 59, 999); 

  if (now >= start && now <= end) return t('Active');
  if (now < start) return t('Soon');
  if (now > end) return t('Finished');
  return t('Unknown');
});


</script>